export function hideFromUI(element: HTMLElement) {
    if (element) {
        element.style.display = 'none'
    }

}